import React from 'react';
import { Box } from '@chakra-ui/react';

interface BackButtonProps {
  onClick: () => void;
  borderColor?: string;
  arrowStrokeColor?: string;
  backgroundColor?: string;
  borderWidth?: string;
  size?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  borderColor = '#90909A',
  arrowStrokeColor = '#FFFFFF',
  backgroundColor = 'rgba(28, 28, 30, 0.8)',
  borderWidth = '1px',
  size = '38px'
}) => {
  return (
    <Box
      width={size}
      height={size}
      border={`${borderWidth} solid ${borderColor}`}
      borderRadius="50%"
      backgroundColor={backgroundColor}
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"      
      onClick={onClick}
      _hover={{
        borderColor: borderColor,
        backgroundColor: backgroundColor.includes('rgba') 
          ? backgroundColor.replace(/\d+(\.\d+)?(?=\))/, (match) => {
              const opacity = parseFloat(match);
              return opacity < 1 ? String(opacity + 0.1) : match;
            })
          : backgroundColor
      }}
    >
      <svg
        width="23"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        stroke={arrowStrokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginLeft: '-4.5px', marginTop: '0px' }}
      >
        <path d="M10 2L4 6.5L10 11" />
        <path d="M5 6.5H40" />
      </svg>
    </Box>
  );
};

export default BackButton;

